import { createContext, useContext } from 'react';
export const ViewerDataContext = createContext({
    useViewerData() {
        return { loading: false, error: new Error('Missing viewer-data module') };
    },
});
export function useViewerData() {
    return useContext(ViewerDataContext).useViewerData();
}
//# sourceMappingURL=viewer-data.js.map